import * as React from "react"

const Share = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      d="m8 2.293.354.354 2.5 2.5.353.353-.707.707-.354-.353L8.5 4.207V10.5h-1V4.207L5.854 5.854l-.354.353-.707-.707.353-.353 2.5-2.5L8 2.293ZM13 10v3.5H3V10h1v2.5h8V10h1Z"
      clipRule="evenodd"
    />
  </svg>
)

export default Share
